import VisitasTecnicasView from "@/views/visita-tecnica/VisitaTecnicaView.vue";
import ZoomSelecProdutorVisita from "@/components/visita-tecnica/ZoomSelecProdutorVisita.vue";
import MenuVisitaView from "@/views/visita-tecnica/MenuVisitaView";
import RebanhoVisitaCard from "@/components/visita-tecnica/RebanhoVisitaCard.vue";
import ProducaoVisitaCard from "@/components/visita-tecnica/ProducaoVisitaCard.vue";
import InstalacoesVisitaCard from "@/components/visita-tecnica/InstalacoesVisitaCard.vue";
import NutricaoAlimentacaoVisitaCard from "@/components/visita-tecnica/NutricaoAlimentacaoVisitaCard.vue";
import LctoPesagensPennState from "@/components/visita-tecnica/LctoPesagensPennState.vue";
import SilagemDadosVisita from "@/components/visita-tecnica/SilagemDadosVisita.vue";
import LocomocaoVisitaCard from "@/components/visita-tecnica/LocomocaoVisitaCard.vue";
import ObservacoesGeraisVisitaCard from "@/components/visita-tecnica/ObservacoesGeraisVisitaCard.vue";
import PennStateDadosVisita from "@/components/visita-tecnica/PennStateDadosVisita.vue";
import AvaliacaoFezesDadosVisita from "@/components/visita-tecnica/AvaliacaoFezesDadosVisita.vue";
import DietaSugeridaDadosVisita from "@/components/visita-tecnica/DietaSugeridaDadosVisita.vue";
import AdicionarAlimentoDieta from "@/components/visita-tecnica/AdicionarAlimentoDieta.vue";
import DialogSincDadosVisita from "@/components/visita-tecnica/DialogSincDadosVisita.vue";

export default [
  {
    path: "/visita-tecnica",
    name: "Visitas Técnicas",
    component: VisitasTecnicasView,
    meta: {
      requiresAuth: true,
      sync: false,
      online: false,
      cod: 2684,
    },
    children: [
      { path: "selecionar-produtor", component: ZoomSelecProdutorVisita },
      { path: "sincronizar", component: DialogSincDadosVisita },
    ],
  },
  {
    path: "/visita-tecnica/:id",
    name: "Visitas Técnicas",
    component: MenuVisitaView,
    meta: {
      requiresAuth: true,
      sync: false,
      online: false,
      cod: 2684,
    },
    children: [
      { path: "rebanho", component: RebanhoVisitaCard },
      { path: "producao", component: ProducaoVisitaCard },
      { path: "instalacoes", component: InstalacoesVisitaCard },
      {
        path: "nutricao-alimentacao",
        component: NutricaoAlimentacaoVisitaCard,
        children: [
          {
            path: "silagem",
            component: SilagemDadosVisita,
          },
          {
            path: "penn-state",
            component: PennStateDadosVisita,
            children: [
              { path: "pesagens-peneiras", component: LctoPesagensPennState },
            ],
          },
          {
            path: "avaliacao-fezes",
            component: AvaliacaoFezesDadosVisita,
          },
          {
            path: "dieta-sugerida",
            component: DietaSugeridaDadosVisita,
            children: [
              {
                path: ":id_lote/adicionar-alimento",
                component: AdicionarAlimentoDieta,
              },
            ],
          },
        ],
      },

      { path: "locomocao", component: LocomocaoVisitaCard },
      { path: "observacoes-gerais", component: ObservacoesGeraisVisitaCard },
    ],
  },
];
